import "./AiDisclaimer.scss";

export interface AiDisclaimerProps {
  /** Overrides the default disclaimer copy when a screen needs more specific wording. */
  message?: string;
  /** Additional class name applied to the root element. */
  className?: string;
}

const DEFAULT_DISCLAIMER_MESSAGE =
  "AI-generated content. Insights are produced dynamically and should be verified by PwC Advisors before being relied upon.";

/**
 * Reusable disclaimer shown under AI-generated content (e.g. AI Summary, AI Insights, AI Chat)
 * so users are consistently reminded to verify the output before acting on it.
 */
export function AiDisclaimer({ message = DEFAULT_DISCLAIMER_MESSAGE, className = "" }: AiDisclaimerProps) {
  return (
    <p className={`shared-ai-disclaimer ${className}`.trim()} role="note">
      <span className="Appkit4-icon icon-information-outline shared-ai-disclaimer__icon" aria-hidden="true" />
      <span>{message}</span>
    </p>
  );
}
